<template>
	
	<div class="filter-group">

		<h4 class="heading heading--5">{{ title }}</h4>

		<ul>

			<li v-for="(option, index) in optionsWithJobs" :key="option.value">

				<filter-component v-bind:groupKey="groupKey" v-bind:optionIndex="index" v-bind:label="option.title" v-bind:value="option.value" v-bind:jobs="option.jobs"></filter-component>

			</li>
			
		</ul>
		
	</div>

</template>
 
<script>
import FilterComponent from './filter.vue'

export default {
	props: {
		groupKey: String,
		id: Number,
		title: String,
		options: Array
	},
	components: {
		FilterComponent
	},
	computed: {
		optionsWithJobs () {
			return this.options.filter( (item) => { return item.jobs > 0 } )
		}
	}
}
</script> 